import { Link } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';

import './about_us_section_style.scss';

export const AboutUsSection = ({
    fields
}) => {
    return <section id="about-us-section" className="home-section">
        <div className="container">
            <div className='inner-wrapper'>
                <span className='main-category'>About Us</span>
                <h2 className='title'>
                    <span className='title-first'>{fields?.aboutus_title}</span>
                    <span className='title-second'>{fields?.aboutus_title_2}</span>
                </h2>
                <div className='section-content'>
                    <div className='section-left-content' style={{ backgroundImage: `url(${fields?.aboutus_image})` }}>
                    </div>
                    <div className='section-right-content'>
                        <div className='description' dangerouslySetInnerHTML={{__html: fields?.aboutus_description}}>
                        </div>
                        <Link to={removeBaseUrl(fields?.aboutus_button?.button_link)} className='button btn-white'>{fields?.aboutus_button?.button_label}</Link>
                    </div>
                </div>
            </div>
       </div>
    </section>
}